module.exports = __webpack_public_path__ + "img/university_6.0cbdc7c6.jpg";